const EVENTS = {
  REGISTER: 'AUTH__REGISTER',
  LOGIN: 'AUTH__LOGIN',
  AUTH_SOCIAL: 'auth_social',
  SIGNUP_FORM_BUTTON_CLICK: 'Click Signup Button',
};

export default EVENTS;
